import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { getAllClans } from "../api/getAllClans";
import { sendTelegramMessage } from "../api/sendTelegramMessage";
import { getMedalImage } from "../utils/getMedalImage";
import { debounce } from "../utils/debounce";
import { formatUserCount } from "../utils/formatUserCount";

import Layout from "../components/Layout/Layout";
import NavBar from '../components/NavBar/NavBar';
import coinIcon from '../assets/coin2.png';
import userIcon from '../assets/userIcon.png';
import energyIcon from '../assets/energy.png';
import closeIcon from '../assets/closeIcon.png';
import astronaut from '../assets/astronaut.png';
import multiTapIcon from '../assets/multiTapIcon.png';

const JoinClan = () => {
    const token = sessionStorage.getItem('token');
    const chatId = sessionStorage.getItem('chatId');
    const navigate = useNavigate();
    const dropdownRef = useRef(null);
    const [data, setData] = useState([]);
    const [dropdownVisible, setDropdownVisible] = useState(false);

    useEffect(() => {
        const getClansInfo = async () => {
            const allClansData = await getAllClans(token);
            setData(allClansData);
        };

        getClansInfo();
    }, []);

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownVisible(false);
            }
        };

        if (dropdownVisible) {
            document.addEventListener('mousedown', handleOutsideClick);
        } else {
            document.removeEventListener('mousedown', handleOutsideClick);
        }

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [dropdownVisible, setDropdownVisible]);

    const handleClick = (id) => {
        navigate(`/joinClan/${id}`);
    };

    const toggleDropdown = () => {
        setDropdownVisible(!dropdownVisible);
    };

    const closeDropdown = () => {
        setDropdownVisible(false);
    }

    const createClan = async () => {
        const points = parseInt(sessionStorage.getItem('points'), 10);
        if (points < 500000) {
            localStorage.setItem('notification', 'Not enough coins');
            navigate(`/`);
        } else {
            const message = "Please send me the command: /createClan";
            await sendTelegramMessage(chatId, message);
            if (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.close) {
                window.Telegram.WebApp.close();
            } else {
                console.error('Telegram WebApp API is not available.');
            }
        }
    }
    const debouncedCreateClan = debounce(createClan, 300);

    return (
        <Layout>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
                <img src={coinIcon} alt="Coin Icon" style={{ marginTop: '1.4375rem', width: '5rem', height: '5rem' }} />
                <span style={{ marginTop: '2.375rem', color: 'white', fontFamily: 'Poppins', fontSize: '1.75rem', fontWeight: '600' }}>Join Clan</span>
                <span style={{ marginTop: '1.25rem', color: '#F1F1F1', fontFamily: 'Poppins', fontSize: '1rem', fontWeight: '400' }}>These clans recruiting now.</span>
                <span style={{ color: '#F1F1F1', fontFamily: 'Poppins', fontSize: '1rem', fontWeight: '400' }}>Do you wanna join?</span>
                <div style={{ width: '88%', paddingInline: '1rem' }}>
                    <button style={{ width: '100%', background: 'linear-gradient(45deg, #5DA8FF, #0064D7)', paddingBlock: '0.9rem', border: 'none', marginTop: '2.1875rem', borderRadius: '18.75rem', color: 'white', fontFamily: 'Poppins', fontSize: '0.9rem', cursor: 'pointer' }} onClick={toggleDropdown}>
                        Create Clan
                    </button>
                    <div style={{ marginTop: '1.875rem', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', borderRadius: '1.25rem', background: 'rgba(140,140,140,0.1)', marginBottom:"30px", backdropFilter: 'blur(0.5rem)', WebkitBackdropFilter: 'blur(0.5rem)', padding: '1rem' }}>
                        {data?.map(item => (
                            <div key={item._id} onClick={() => handleClick(item._id)} style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between', cursor: 'pointer' }}>
                                <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', marginTop: '0.8125rem' }}>
                                    <img src={item.profilePictureUrl} alt="Avatar" style={{ width: '3rem', height: '3rem', position: 'relative', borderRadius: '50%', zIndex: 0 }} />
                                    <div style={{ display: 'flex', alignItems: 'center', borderRadius: '9.375rem', background: 'linear-gradient(45deg, #5DA8FF, #0064D7)', paddingBlock: '0.3125rem', paddingInline: '0.46875rem', position: 'relative', top: '-0.8125rem', zIndex: 1 }} >
                                        <img src={userIcon} alt="User Icon" style={{ width: '0.625rem', height: '0.625rem' }} />
                                        <span style={{ color: 'white', fontFamily: 'Poppins', fontSize: '0.5rem', fontWeight: '500', marginLeft: '0.4375rem' }}>{formatUserCount(item.userCount)}{item.userCount > 1000 && '+'}</span>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '1rem', gap: '0.3125rem', width: '100%' }}>
                                    <span style={{ fontFamily: 'Poppins', fontWeight: '600', fontSize: '1rem', color: 'white' }}>{item.clanName}</span>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <span style={{ fontFamily: 'Poppins', fontWeight: '500', fontSize: '0.8rem', color: 'white', opacity: '0.6' }}>{formatUserCount(item.points)}{item.points > 1000 && '+'}</span>
                                        {item.energyBonus > 0 && (
                                            <div style={{ display: 'flex', alignItems: 'center', marginLeft: '1.1875rem' }}>
                                                <img src={energyIcon} alt="Energy Icon" style={{ width: '1rem', height: '1rem' }} />
                                                <span style={{ fontFamily: 'Poppins', fontWeight: '400', fontSize: '1rem', color: 'white', marginLeft: '0.25rem' }}>+{item.energyBonus}</span>
                                            </div>
                                        )}
                                        {item.tapBonus > 0 && (
                                            <div style={{ display: 'flex', alignItems: 'center', marginLeft: '1.1875rem' }}>
                                                <img src={multiTapIcon} alt="Multi Tap Icon" style={{ width: '1rem', height: '1rem' }} />
                                                <span style={{ fontFamily: 'Poppins', fontWeight: '400', fontSize: '1rem', color: 'white', marginLeft: '0.25rem' }}>+{item.tapBonus}</span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {item.ranking > 3 ? (
                                    <span style={{ fontFamily: 'Poppins', fontWeight: '700', fontSize: '1rem', color: '#0064D7', background: 'linear-gradient(45deg, #5DA8FF, #0064D7)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', marginLeft: '1.875rem' }}>
                                        {item.ranking}
                                    </span>
                                ) : (
                                    <img src={getMedalImage(item.ranking)} alt="Gold Medal" style={{ width: '1.875rem', height: '1.875rem', marginLeft: '1.875rem' }} />
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            {dropdownVisible && (
                <div style={{width:'100vw', height:'100vh', display:'flex', justifyContent:'center', alignItems:'center', position:'fixed', top:'0px'}}>
                    <div ref={dropdownRef} style={{ width: '92%' , borderRadius: '1.25rem', background: 'rgba(140,140,140,0.1)', marginInline:"40px" , backdropFilter: 'blur(3rem)', WebkitBackdropFilter: 'blur(3rem)', display: 'flex', flexDirection: 'column', padding: '1rem', alignItems: 'center' }}>
                    <button style={{ position: 'absolute', top: '1rem', right: '1rem', float: 'right', background: 'none', border: 'none', cursor: 'pointer' }} onClick={closeDropdown} >
                        <img src={closeIcon} alt="Close Icon" style={{ width: '1.5rem', height: '1.5rem' }} />
                    </button>
                    <img src={astronaut} alt="Astronaut" style={{ width: '5.25rem', height: '5.25rem' }} />
                    <span style={{ marginTop: '0.5625rem', fontFamily: 'Poppins', fontWeight: '600', fontSize: '1.5rem', color: 'white' }}>Create Clan</span>
                    <span style={{ marginTop: '0.5625rem', fontFamily: 'Poppins', fontWeight: '400', fontSize: '0.9rem', color: '#F1F1F1' }}>Invite Friends to your Commuity</span>
                    <span style={{ fontFamily: 'Poppins', fontWeight: '400', fontSize: '0.9rem', color: '#F1F1F1' }}>and Earn Mooncoins even faster</span>
                    <div style={{ marginTop: '0.5625rem' }}>
                        <span style={{ marginRight: '0.25rem', fontFamily: 'Poppins', fontWeight: '700', fontSize: '1.3rem', color: 'white' }}>500,000</span>
                        <span style={{ fontFamily: 'Poppins', fontWeight: '400', fontSize: '1rem', color: '#F1F1F1', opacity: '0.6' }}>/ per clan</span>
                    </div>
                    <button style={{ width: '80%', background: 'linear-gradient(45deg, #5DA8FF, #0064D7)', paddingBlock: '0.8rem', border: 'none', margin: '26px', borderRadius: '18.75rem', color: 'white', fontFamily: 'Poppins', fontSize: '0.9rem', cursor: 'pointer' }} onClick={debouncedCreateClan}>
                        Create
                    </button>
                    </div>
                </div>
            )
            }
            <div style={{height: '10px'}}></div>
            {/* <NavBar /> */}
        </ Layout >
    );
};

export default JoinClan;